const config = { basename: '/', defaultPath: '/', borderRadius: 12, fontFamily: `'Quicksand', 'Roboto', sans-serif` };

export default config;
